import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function PricingSection() {
  return <section id="offer" className="scroll-mt-20 bg-brand-alt px-4 py-20 md:py-28" data-id="element-130" data-mp="19jxdvgf8bdcx">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-131" data-mp="1ehytfrdg4ujn">
        <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-132" data-mp="1egdyw1r4tbls">
          PRECIO POR TIEMPO LIMITADO
        </p>
        <h2 className="mb-12 text-3xl font-black text-brand-blue md:text-4xl" data-id="element-133" data-mp="1nbbwhm585cjg">
          🏆 Oferta Especial de Lanzamiento
        </h2>
        <div className="relative mx-auto max-w-xl rounded-[2rem] border-2 border-brand-orange bg-brand-alt p-8 pt-10 shadow-xl md:p-12" data-id="element-134" data-mp="1s82ewg4i4k81">
          <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-brand-orange px-5 py-2 text-[10px] font-extrabold tracking-[0.14em] text-white" data-id="element-135" data-mp="227t4q4i4ab1s">
            MÚSICA LISTA
          </div>
          <div className="space-y-4 text-left" data-id="element-136" data-mp="7utoqa9tretz">
            <PriceLine label="12 Tomos Completos" price="$163.000" data-id="element-137" data-mp="7vmt54lb9s8y" />
            <PriceLine label="5 Bonos Exclusivos" price="$158.000" data-id="element-138" data-mp="1mi9c99fdp8mf" />
            <div className="flex items-center justify-between border-t border-brand-dark pt-5 text-sm font-bold" data-id="element-139" data-mp="1hpol6fnux9ml">
              <span data-id="element-140" data-mp="1crn1bsilx6a2">VALOR TOTAL:</span>
              <span className="text-brand-purple line-through" data-id="element-141" data-mp="1coim803lsq4m">$321.000</span>
            </div>
          </div>
          <div className="my-8 border-y border-brand-dark py-7" data-id="element-142" data-mp="25firsfhl21ye">
            <p className="text-xs font-extrabold tracking-[0.16em] text-brand-green" data-id="element-143" data-mp="25er8o4569wp0">SOLO POR HOY</p>
            <p className="mt-2 font-serif text-6xl font-black tracking-tight text-brand-blue md:text-7xl" data-id="element-144" data-mp="20h8w83ry4zc9">
              $19.990
            </p>
          </div>
          <CTAButton href="https://musicalista.impultienda.ar/checkout" className="w-full py-5 text-lg" data-id="element-145" data-mp="1rgj357u2ln28">
            QUIERO EL PACK MÚSICA LISTA
          </CTAButton>
          <p className="mt-6 text-xs font-semibold text-brand-gray" data-id="element-146" data-mp="g0clvpdpsjw5">Pago único · Acceso inmediato</p>
        </div>
      </Reveal>
    </section>;
}
function PriceLine({
  label,
  price
}: {
  label: string;
  price: string;
}) {
  return <div className="flex items-center justify-between border-b border-brand-dark pb-4 text-sm" data-id="element-147" data-mp="mg349co0pg7h">
      <span className="font-medium" data-id="element-148" data-mp="7j2dpchkbral">{label}</span>
      <span className="font-bold text-brand-blue line-through" data-id="element-149" data-mp="ci5gsrdzfnfx">{price}</span>
    </div>;
}